import { DeepReadonly, IResidencesForUKAddresses } from 'types';

import { deepFreeze } from '../utils/deepFreeze.js';

export const descriptionUKResidence: DeepReadonly<IResidencesForUKAddresses[]> = deepFreeze([
  { name: 'I am a UK Citizen - England' },
  { name: 'I am a UK Citizen - Scotland' },
  { name: 'I am a UK Citizen - Wales' },
  { name: 'I am a UK Citizen - Northern Ireland' },
  { name: 'I am a British Citizen - Channel Islands and Isle of Man' },
  { name: 'I am a British Citizen - British Overseas Territories' },
  { name: 'I am an EU National (non-UK Citizen)' },
  { name: 'I am an EEA or Swiss National' },
  { name: 'I am a Child of a Turkish Worker' },
  { name: 'I am a Refugee' },
  { name: 'I have protection status (humanitarian protection or similar)' },
  { name: 'I am Settled in the UK' },
  { name: 'Other' },
]);
